import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { FirebaseAppCheck } from "@capacitor-firebase/app-check";

// IONIC & VUE
import { IonApp, IonRouterOutlet } from "@ionic/vue";
import { onBeforeMount } from "vue";

// STORES
import { useAuthStore } from "@/stores/AuthStore";
import compAnalytics from "@/composables/analyticsComp";

export default /*#__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {

// CAPACITOR PLUGINS
const authStore = useAuthStore();

// COMPOSABLES
const { logEvent } = compAnalytics();

// LC HOOKS
onBeforeMount(async () => {
  // CHECK IF AUTHENTICATED
  authStore.checkIfAuthenticated();

  // APP CHECK
  const debug = window.location.href.includes("localhost") ? true : false;
  await FirebaseAppCheck.initialize({
    siteKey: "6Lck7S8qAAAAAJ-VyJQosij7wjQmUERlJ79pCZfI",
    debug: debug,
  });
  await FirebaseAppCheck.setTokenAutoRefreshEnabled({ enabled: true });

  // SEND ANALYTICS EVENTS QUEUE
  setInterval(() => {
    const eventsToSend = JSON.parse(localStorage.getItem("events") || "[]");
    localStorage.setItem("events", "[]");
    eventsToSend.forEach((event: any) => {
      logEvent(event.action, event.eventId);
    });
  }, 1000);
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(IonApp), null, {
    default: _withCtx(() => [
      _createVNode(_unref(IonRouterOutlet))
    ]),
    _: 1
  }))
}
}

})